import type {
  Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type {
  KaminoInterestedPartyCreateMutation,
  KaminoInterestedPartyDeleteMutation,
  KaminoInterestedPartyUpdateMutation,
} from '@/graphql/generated/graphql';

const membershipDocumentQueries = ['membershipDocuments', 'membershipDocumentsByEntityPolicy'];
const kaminoPolicyQueries = ['kaminoPolicy', 'kaminoPolicyByScopedPolicyNumber'];

function invalidateKaminoInterestedPartyMutationCache(
  policyDocumentRegenerationRequested: boolean,
  cache: Cache,
) {
  invalidateQuery('memberships', cache);

  if (policyDocumentRegenerationRequested) {
    invalidateQuery(membershipDocumentQueries, cache);
    invalidateQuery(kaminoPolicyQueries, cache);
  }
}

const interestedPartyMutations: UpdatesConfig['Mutation'] = {
  kaminoInterestedPartyCreate: (data: KaminoInterestedPartyCreateMutation, __: Variables, cache: Cache) => {
    const response = data.kaminoInterestedPartyCreate;
    if (response) {
      invalidateKaminoInterestedPartyMutationCache(response.policyDocumentRegenerationRequested, cache);
    }
  },

  kaminoInterestedPartyUpdate: (data: KaminoInterestedPartyUpdateMutation, __: Variables, cache: Cache) => {
    const response = data.kaminoInterestedPartyUpdate;
    if (response) {
      invalidateKaminoInterestedPartyMutationCache(response.policyDocumentRegenerationRequested, cache);
    }
  },

  kaminoInterestedPartyDelete: (data: KaminoInterestedPartyDeleteMutation, __: Variables, cache: Cache) => {
    const response = data.kaminoInterestedPartyDelete;
    if (response) {
      invalidateKaminoInterestedPartyMutationCache(response.policyDocumentRegenerationRequested, cache);
    }
  },
};
export default interestedPartyMutations;
